/**
 * <notify-when-available> — docs/24 §10, defect D1.
 *
 * A disclosure, not a dialog. The form is inline behind a toggle: it replaces
 * a dead SOLD OUT button in place, the product context stays on screen, and
 * there is no focus trap to get wrong. docs/43 §4.1's dialog contract is for
 * things that interrupt the page; this does not.
 *
 * Progressive enhancement: the panel is `hidden` in the markup and only ever
 * revealed from here, EXCEPT when the form has just posted or has errors — in
 * those cases Liquid renders it open, because a confirmation or an error the
 * visitor cannot see is worse than a panel that starts expanded.
 */
(function () {
  class NotifyWhenAvailable extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.notify__toggle');
      this.panel = this.querySelector('.notify__panel');
      if (!this.toggle || !this.panel) return;

      // A success message or a validation error means the page came back from
      // a POST. Open it without being asked.
      if (this.querySelector('.notify__success, .notify__error')) {
        this.open(false);
      }

      this.toggle.addEventListener('click', () => {
        if (this.toggle.getAttribute('aria-expanded') === 'true') this.close();
        else this.open(true);
      });
    }

    open(moveFocus) {
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      // Focus the email field, which is the only thing the visitor came here
      // to do. Not on the post-back path — Liquid autofocuses the
      // confirmation there, and stealing it would re-announce the form.
      if (moveFocus) this.panel.querySelector('input[type="email"]')?.focus();
    }

    close() {
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('notify-when-available')) {
    customElements.define('notify-when-available', NotifyWhenAvailable);
  }
})();
